module.exports = __webpack_public_path__ + "static/img/login_back.335cb5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/newCode/userLogin/login_back.jpg
// module id = 1397
// module chunks = 2